import { render, staticRenderFns } from "./NotSubmitTable.vue?vue&type=template&id=353c0a0a&scoped=true"
import script from "./NotSubmitTable.vue?vue&type=script&lang=js"
export * from "./NotSubmitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c0a0a",
  null
  
)

export default component.exports